import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable()
export abstract class ValidatorService {
        // Taken From https://github.com/irossimoline/angular4-material-table //
  abstract getRowValidator(): FormGroup;
}
